import { combineReducers } from "redux";

import authSlice from "./auth/authSlice";
import contentSlice from "./Content/contentTextSlice";
import contentTrainingSlice from "./Content/contentTrainingSlice";
import MassMessageSlice from "./MassMessage/MassMessageSlice";
import userSlice from "./user/userSlice.";
import salesSlice from "./sales/SalesSlice";
import InventorySlice from "./Inventory/InventorySlice";
import communicationFormSlice from "./communicationForm/communicationFormSlice";
import lineItemSlice from "./LineItem/LineItemSlice";
import uploadDocsSlice from "./uploadDocs/uploadDocsSlice";
import uploadManagerSlice from "./uploadManager/uploadManagerSlice";
import communicationSlice from "./communication/communicationSlice";
import taskSlice from "./task/taskSlice";
import inventoryLineItemSlice from "./LineItem/InventoryLineItemSlice";
import dataSlice from "./data/dataSlice";

import { authApi } from "./Services/authServices";
import { textingApi } from "./Services/textingServices";
import { trainingApi } from "./Services/trainingServices";
import { salesApi } from "./Services/salesServices";
import { userApi } from "./Services/userServices";
import { storeApi } from "./Services/storeServices";
import { ordersApi } from "./Services/ordersServices";
import { tasksApi } from "./Services/tasksServices";
import { inventoryApi } from "./Services/inventoryServices";
import { statsApi } from "./Services/statsServices";
import { projectedEarningsApi } from "./Services/projectedEarnings";
import { payrollApi } from "./Services/payrollServices";
import { payrollAdminApi } from "./Services/payrollAdminServices";
import { deductionApi } from "./Services/deductionServices";
import { terminationApi } from "./Services/terminationServices";
import { trucksInformationApi } from "./Services/truckServices";
import { orgChartApi } from "./Services/orgChartServices";
import { tooltipApi } from "./Services/tooltipServices";
import { leadsApi } from "./Services/leadsServices";
import { eventsApi } from "./Services/eventsServices";
import { reviewsApi } from "./Services/reviewsServices";
import { tournamentApi } from "./Services/tournamentServices";
import { nativeViewsApi } from "./Services/nativeViewsServices";
import { taskCommentApi } from "./Services/taskCommentServices";
import { positionAiApi } from "./Services/positionAiServices";
import { fantasyApi } from "./Services/fantasyServices";
import { repLocationApi } from "./Services/repLocationServices";
import { positionChangeApi } from "./Services/positionChangeServices";
import { incentiveScoringApi } from "./Services/incentiveScoringServices";
import { vendorAdminApi } from "./Services/vendorAdminServices";
import { employeeAdminApi } from "./Services/employeeAdminServices";
import { equipmentAdminApi } from "./Services/equipmentAdminServices";
import { positionAdminApi } from "./Services/positionAdminServices";
import { inventoryAdminApi } from "./Services/inventoryAdminServices";
import { ptoApi } from "./Services/ptoServices";
import { sendLoginApi } from "./Services/sendLoginServices";
import { timeSheetApi } from "./Services/timeSheetServices";
import { invoicesDocumentsApi } from "./Services/invoicesDocumentsServices";
import { manualApi } from "./Services/manualServices";


export default combineReducers({
  auth: authSlice,
  content: contentSlice,
  contentTraining: contentTrainingSlice,
  MassMessage: MassMessageSlice,
  user: userSlice,
  sales: salesSlice,
  lineItem: lineItemSlice,
  Inventory: InventorySlice,
  communicationForm: communicationFormSlice,
  communication: communicationSlice,
  task: taskSlice,
  uploadDocs: uploadDocsSlice,
  uploadManager: uploadManagerSlice,
  inventoryLineItems: inventoryLineItemSlice,
  data: dataSlice,
  [authApi.reducerPath]: authApi.reducer,
  [textingApi.reducerPath]: textingApi.reducer,
  [trainingApi.reducerPath]: trainingApi.reducer,
  [salesApi.reducerPath]: salesApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [storeApi.reducerPath]: storeApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
  [tasksApi.reducerPath]: tasksApi.reducer,
  [inventoryApi.reducerPath]: inventoryApi.reducer,
  [statsApi.reducerPath]: statsApi.reducer,
  [projectedEarningsApi.reducerPath]: projectedEarningsApi.reducer,
  [payrollApi.reducerPath]: payrollApi.reducer,
  [payrollAdminApi.reducerPath]: payrollAdminApi.reducer,
  [deductionApi.reducerPath]: deductionApi.reducer, 
  [trucksInformationApi.reducerPath]: trucksInformationApi.reducer,
  [terminationApi.reducerPath]: terminationApi.reducer,
  [orgChartApi.reducerPath]: orgChartApi.reducer,
  [tooltipApi.reducerPath]: tooltipApi.reducer,
  [eventsApi.reducerPath]: eventsApi.reducer,
  [leadsApi.reducerPath]: leadsApi.reducer,
  [reviewsApi.reducerPath]: reviewsApi.reducer,
  [tournamentApi.reducerPath]: tournamentApi.reducer,
  [nativeViewsApi.reducerPath]: nativeViewsApi.reducer,
  [taskCommentApi.reducerPath]: taskCommentApi.reducer,
  [positionAiApi.reducerPath]: positionAiApi.reducer,
  [fantasyApi.reducerPath]: fantasyApi.reducer,
  [repLocationApi.reducerPath]: repLocationApi.reducer,
  [positionChangeApi.reducerPath]: positionChangeApi.reducer,
  [incentiveScoringApi.reducerPath]: incentiveScoringApi.reducer,
  [vendorAdminApi.reducerPath]: vendorAdminApi.reducer,
  [employeeAdminApi.reducerPath]: employeeAdminApi.reducer,
  [equipmentAdminApi.reducerPath]: equipmentAdminApi.reducer,
  [positionAdminApi.reducerPath]: positionAdminApi.reducer,
  [inventoryAdminApi.reducerPath]: inventoryAdminApi.reducer,
  [ptoApi.reducerPath]: ptoApi.reducer,
  [sendLoginApi.reducerPath]: sendLoginApi.reducer,
  [timeSheetApi.reducerPath]: timeSheetApi.reducer,
  [invoicesDocumentsApi.reducerPath]: invoicesDocumentsApi.reducer,
  [manualApi.reducerPath]: manualApi.reducer,
});
